import { Button, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { makeStyles } from "@mui/styles";
import config from "config";
import { useTemplateFontSettings } from "styles/templateFontSettings";
import DeleteIcon from '@mui/icons-material/Delete';
import { MEETING_VIDEO } from "app/utils/constants/customConstant";
import { deleteObjectApi, putUpdateObjectApi } from "api/general";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";

const useStyles = makeStyles({
  selectedRow: {
    backgroundColor: "#e0e0e0",
  },
  tableRow: {
    cursor: "pointer",
  },
});
function VideoListTable({ videos, onVideoSelect, selectedVideo, isFullScreen }) {
  const classes = useStyles();

  const { baseFontSize, lineHeight, iconFontSize } = useTemplateFontSettings();
  const [data, setData] = useState([]);
  useEffect(() => {
    setData(videos);
  }, [videos]);


  const deleteItem = (item) => {
    Swal.fire({
      title: 'Silme İşlemi',
      text: "'" + item.indexNo + "' sayılı videoyu silmek istediğinizden emin misiniz?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet Sil',
      cancelButtonText: "Vazgeç",
      customClass: {
        container: 'swal-container-custom'
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        const updatedItem = { ...item, status: 0 };
        const result = await putUpdateObjectApi(MEETING_VIDEO, updatedItem);
        setData([...data.filter(x => x.id !== item.id)])
        if (result.status) {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'İşlem başarılı.',
            showConfirmButton: false,
            timer: 1500,
            customClass: {
              container: 'swal-container-custom'
            }
          });
        }
      }
    })
  }


  return (
    <div style={{
      position: "relative",
      maxHeight: isFullScreen ? "850px" : "580px",
      overflowY: "auto"
    }}>

      <Table className="small-font-table" size="small" style={{ fontSize: baseFontSize, lineHeight: lineHeight }}>

        <TableHead>
          <TableRow>
            <TableCell style={{ fontSize: baseFontSize }}>Sıra</TableCell>
            <TableCell style={{ fontSize: baseFontSize }}>Ön İzleme</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data &&
            data.map((item, index) => (
              <TableRow
                key={item.id || index}
                className={`${classes.tableRow} ${selectedVideo && selectedVideo.id === item.id ? classes.selectedRow : ""
                  }`}
                onClick={() => onVideoSelect(item)}
              >
                <TableCell style={{ fontSize: baseFontSize }}>{item.indexNo}</TableCell>

                <TableCell>
                  <video
                    width="100"
                    height="60"
                    autoPlay
                    muted
                    loop
                    playsInline
                    style={{ borderRadius: "5px", pointerEvents: "none" }}
                  >
                    <source src={`${config.apiUrl}/uploads${item.filePath}`} type="video/mp4" />
                    Tarayıcınız video etiketini desteklemiyor.
                  </video>
                </TableCell>
                <TableCell style={{ fontSize: baseFontSize }}>


                  <Button style={{ minWidth: '40px', fontSize: iconFontSize }} key="two" onClick={() => deleteItem(item)} >
                    <DeleteIcon color='error' fontSize='small' />
                  </Button>

                </TableCell>

              </TableRow>
            ))}
        </TableBody>
      </Table>
    </div>
  );
}

const style = document.createElement('style');
style.innerHTML = `
    .swal-container-custom {
        z-index: 10000 !important;
    }
`;
document.head.appendChild(style);

export default VideoListTable;
